<template>
	<article :id="id" :class="[labelClass, 'dc-post-grid-card', 'person-card']">
		<div v-if="image" class="card-image">
			<img :src="image.src" :srcset="image.srcset" :alt="image.alt" />
		</div>
		<div ref="cardContentWrapper" class="card-content">
			<h3 v-if="name" class="card-name">{{ name }}</h3>
			<p v-if="title" class="card-title" v-html="title"></p>
			<p v-if="phone" class="card-phone">
				<a :href="formattedPhone.href">{{ formattedPhone.str }}</a>
			</p>
			<p v-if="email" class="card-email">
				<a :href="'mailto:' + email">{{ email }}</a>
			</p>
		</div>
	</article>
</template>

<script>
import Post from './Post';
import PhoneNumber from 'awesome-phonenumber';

export default {
	extends: Post,
	props: {
		name: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		phone: {
			type: String,
			required: true,
		},
		email: {
			type: String,
			required: true,
		},
	},
	computed: {
		formattedPhone() {
			const phone = new PhoneNumber('+' + this.phone);
			return {
				href: 'tel:' + phone.getNumber(),
				str: phone.getNumber('international'),
			};
		},
	},
};
</script>
